/**
 * Define all available breakpoints here.
 *
 * If changed also update $breakpoints in /_common/sass/_project/_config.scss!
 *
 * @var {Object}
 *
 * @see S.mq()
 */
S.breakpoints = {
    tablet: 'only screen and (min-width: #{em(768px)})',
    desktop: 'print, only screen and (min-width: #{em(1024px)})',
    print: 'print',
    dark: 'only screen and (prefers-color-scheme: dark)',
    'reduced-motion': 'only screen and (prefers-reduced-motion: reduce)',
};
